import { render, staticRenderFns } from "./Underlying.vue?vue&type=template&id=4cf0ac74&scoped=true&"
import script from "./Underlying.js?vue&type=script&lang=js&"
export * from "./Underlying.js?vue&type=script&lang=js&"
import style0 from "./Underlying.vue?vue&type=style&index=0&id=4cf0ac74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf0ac74",
  null
  
)

export default component.exports